
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfigTemplateCard',

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    shortcode: {
      type: String,
      required: true
    },
    loadOnboarding: {
      type: Boolean,
      default: false
    },
    allowCrud: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onboard() {
      this.$emit('onboard', {
        title: this.title,
        shortcode: this.shortcode
      })
    },
    async editTemplate(): Promise<void> {
      await this.$router.push(
        this.$generateRoute(['settings', 'auto-onboard', this.shortcode], false, true)
      )
      setTimeout(() => {
        this.$root.$emit('auto-onboard-config-edit', this.shortcode)
      }, 400)
    }
  }
})
